import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-146d7fdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field-list-box" }
const _hoisted_2 = { class: "field-list-operat-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips-box" }, "用户报名时要填的内容，顺序就是前台展示顺序", -1))
const _hoisted_4 = { class: "field-name-box" }
const _hoisted_5 = { class: "operat-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ui_switch = _resolveComponent("ui-switch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.addItem
      }, {
        default: _withCtx(() => [
          _createTextVNode("新增字段")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_3
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.rows,
      style: {"width":"100%"},
      border: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "字段名称",
          "min-width": "150"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_input, {
                modelValue: row.name,
                "onUpdate:modelValue": ($event: any) => ((row.name) = $event),
                onChange: _ctx.sync
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
              (row.isSystem == 1)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    size: "small",
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("系统")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "输入提示",
          "min-width": "130"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_input, {
              modelValue: row.placeholder,
              "onUpdate:modelValue": ($event: any) => ((row.placeholder) = $event),
              onChange: _ctx.sync
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "字段类型",
          width: "110"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.getFormatType(row.type)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "必填",
          width: "70"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_ui_switch, {
              trueValue: 1,
              falseValue: 0,
              modelValue: row.isRequire,
              "onUpdate:modelValue": ($event: any) => (_ctx.changeRequire(row, $event))
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "240",
          align: "right"
        }, {
          default: _withCtx(({ row, $index }) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_link, {
                type: "primary",
                underline: false,
                onClick: ($event: any) => (_ctx.editItem($index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("编辑")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              (row.isSystem != 1)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    type: "danger",
                    underline: false,
                    onClick: ($event: any) => (_ctx.removeItem($index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_link, {
                type: "primary",
                underline: false,
                disabled: $index == 0,
                onClick: ($event: any) => (_ctx.upIndex($index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("上移")
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              _createVNode(_component_el_link, {
                type: "primary",
                underline: false,
                disabled: $index == _ctx.rows.length - 1,
                onClick: ($event: any) => (_ctx.downIndex($index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下移")
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}